import { LanguageCode } from '../enum/language-code'
import { applyEntitySchema, sourceJson } from '../../_utils/fcdc-v2'
import { i18nStringSchema } from '../schema/i18n-string.schema'

export class I18nString {
  language?: LanguageCode
  value: string

  constructor(json: any) {
    const source = sourceJson(json) as any
    this.language = this.parseLanguage(source.language)
    this.value = source.value
    applyEntitySchema(this, i18nStringSchema, source, {})
  }

  parseLanguage(l: any): LanguageCode | undefined {
    if (l === undefined || l === null) {
      return undefined
    }

    if (l.length < 5) {
      const entries = Object.entries(LanguageCode)
      const inputLangPart = l.substring(0, 2).toLowerCase()

      let matchedEntry = entries.find(e => {
        const langCodePart = e[1].substring(0, 2).toLowerCase()
        return langCodePart === inputLangPart
      })

      if (!matchedEntry) {
        matchedEntry = entries.find(e => {
          const countryCodePart = e[1]
            .split('-')[1]
            ?.substring(0, 2)
            .toLowerCase()
          return countryCodePart === inputLangPart
        })
      }

      if (matchedEntry) {
        return matchedEntry[1] as LanguageCode
      }

      return l as LanguageCode
    } else {
      return l as LanguageCode
    }
  }
}
